// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kt8DU","input":"styles_input__1RNNv"};